import { controls, currencyToNumber, grouped } from "../../controls";

const rpdr5 = {
  label: "Statement of Farm & Non Farm Sector",
  starting: true,
  url: "rp101m",
  pageLabel: "Statement of Farm & Non Farm Sector",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Report Season" }),
    ...controls.autoComplete({ tab: "filter", controlType: "ManualReportMaster", placeHolder: "Manual Report Master", name: "manual_report_master_code", fastpath: "manual_report_masters" }),

    ...controls.displayText({ tab: "filter", label: "Bank" }),
    ...controls.autoComplete({ tab: "filter", controlType: "Bank", placeHolder: "Bank Code", name: "bank_code", fastpath: "banks" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "bank_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Statement of Farm & Non Farm Sector",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      fields: ["count", "amount"],
      location: "top",
      subtotals: {
        by: "manual_report_type",
        displayIn: "observation"
      },
      grandtotal: { type: "fixed", displayIn: "observation", val: "Grand Total", count: true },
    },
    pivotable: true,
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Scheme",
        accessor: "observation",
        rwidth: "*"
      },
      {
        Header: "01/04/2021 to 31/03/2021",
        columns: [
          {
            Header: "Count",
            accessor: "count",
          },
          {
            Header: "Amount",
            accessor: "amount",
            type: 'currency'
          },
        ]
      }
    ]
  }
};

export default rpdr5;